/**
 * API Service Layer
 * 
 * Centralized API calls with consistent error handling.
 * No PII is logged - only submission IDs and timestamps.
 */

import axios from 'axios';
import { API_BASE_URL } from '../config/constants';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Submit eligibility assessment
 * @param {Object} formData - Form data (name, phone, email, service_interest, reason, consent)
 * @returns {Promise<{blocked: boolean, submission_id?: string, message?: string}>}
 */
export const submitEligibility = async (formData) => {
  try {
    const response = await api.post('/api/eligibility', formData);
    return response.data;
  } catch (error) {
    console.error('Eligibility submission error:', error.message);
    throw error;
  }
};

/**
 * Submit contact form
 * @param {Object} formData - Form data (name, email, phone, message)
 * @returns {Promise<{blocked: boolean, submission_id?: string, message?: string}>}
 */
export const submitContact = async (formData) => {
  try {
    const response = await api.post('/api/contact', formData);
    return response.data;
  } catch (error) {
    console.error('Contact submission error:', error.message);
    throw error;
  }
};

/**
 * Health check
 * @returns {Promise<{status: string, timestamp: string}>}
 */
export const healthCheck = async () => {
  try {
    const response = await api.get('/api/health');
    return response.data;
  } catch (error) {
    console.error('Health check failed:', error.message);
    throw error;
  }
};

/**
 * System check (V2 - requires feature flag)
 * @returns {Promise<Object>} System status information
 */
export const systemCheck = async () => {
  try {
    const response = await api.get('/api/system-check');
    return response.data;
  } catch (error) {
    console.error('System check failed:', error.message);
    throw error;
  }
};

export default {
  submitEligibility,
  submitContact,
  healthCheck,
  systemCheck,
};
